"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Client = exports.AuthClient = void 0;
var authenticated_fetch_1 = __importDefault(require("@iqmetrix/authenticated-fetch"));
var get_environment_1 = __importDefault(require("@iqmetrix/get-environment"));
var get_environment_suffix_1 = __importDefault(require("@iqmetrix/get-environment-suffix"));
var Sentry = __importStar(require("@sentry/minimal"));
var types_1 = require("@sentry/types");
var FailedAuthClientResponseError_1 = require("./FailedAuthClientResponseError");
var AuthClient = /** @class */ (function () {
    function AuthClient() {
        this.hasLoggedIn = false;
        this.me = null;
    }
    AuthClient.prototype.setup = function () {
        return __awaiter(this, void 0, void 0, function () {
            var env, envSuffix, response, userApi, type, user, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 7, , 8]);
                        return [4 /*yield*/, get_environment_1.default()];
                    case 1:
                        env = _a.sent();
                        return [4 /*yield*/, get_environment_suffix_1.default()];
                    case 2:
                        envSuffix = _a.sent();
                        return [4 /*yield*/, authenticated_fetch_1.default("https://accounts" + envSuffix + ".iqmetrix.net/v1/me")];
                    case 3:
                        response = _a.sent();
                        userApi = null;
                        type = response.headers.get("Content-Type");
                        if (!(type != null && type.indexOf("application/json") > -1)) return [3 /*break*/, 5];
                        return [4 /*yield*/, response.json()];
                    case 4:
                        userApi = (_a.sent());
                        return [3 /*break*/, 6];
                    case 5:
                        Sentry.addBreadcrumb({
                            message: "\"AccountsApiError\" Auth response did not return a user object",
                            category: "@iqmetrix/auth",
                            level: types_1.Severity.Error,
                            timestamp: Date.now(),
                        });
                        throw new Error("Auth response did not return a user object");
                    case 6:
                        if (userApi && userApi.Id) {
                            this.me = {
                                id: userApi.Id.toString(),
                                email: userApi.Email,
                                firstName: userApi.FirstName,
                                lastName: userApi.LastName,
                                isExternal: userApi.IsExternal,
                                parentEntityId: userApi.ParentEntityId,
                                picture: userApi.Picture,
                                userName: userApi.UserName,
                            };
                        }
                        else {
                            Sentry.addBreadcrumb({
                                message: "\"AccountsApiError\" Auth response returned a invalid user",
                                category: "@iqmetrix/auth",
                                level: types_1.Severity.Error,
                                timestamp: Date.now(),
                            });
                            throw new Error("Auth response returned a invalid user");
                        }
                        user = this.me;
                        return [2 /*return*/, { user: user, env: env, envSuffix: envSuffix }];
                    case 7:
                        error_1 = _a.sent();
                        Sentry.captureException(error_1);
                        throw error_1;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    AuthClient.prototype.fetch = function (input, options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response, error, error, type, result, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (options && options.mockDataResponse) {
                            return [2 /*return*/, new Promise(function (resolve) { return resolve(options.mockDataResponse); })];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 9, , 10]);
                        return [4 /*yield*/, authenticated_fetch_1.default(input, options)];
                    case 2:
                        response = _a.sent();
                        if (!(response.status >= 400 && response.status <= 499)) return [3 /*break*/, 4];
                        return [4 /*yield*/, FailedAuthClientResponseError_1.FailedAuthClientResponseError.build(response, "RequestUsingAuthClientFailedOnClientSide")];
                    case 3:
                        error = _a.sent();
                        Sentry.addBreadcrumb({
                            message: "\"RequestUsingAuthClientFailedOnClientSide\" " + error.message,
                            category: "@iqmetrix/auth",
                            level: types_1.Severity.Critical,
                            timestamp: Date.now(),
                            data: error,
                        });
                        throw error;
                    case 4:
                        if (!(response.status >= 500)) return [3 /*break*/, 6];
                        return [4 /*yield*/, FailedAuthClientResponseError_1.FailedAuthClientResponseError.build(response, "RequestUsingAuthClientFailedOnServerSide")];
                    case 5:
                        error = _a.sent();
                        Sentry.addBreadcrumb({
                            message: "\"RequestUsingAuthClientFailedOnServerSide\" " + error.message,
                            category: "@iqmetrix/auth",
                            level: types_1.Severity.Fatal,
                            timestamp: Date.now(),
                            data: error,
                        });
                        throw error;
                    case 6:
                        type = response.headers.get("Content-Type");
                        result = response;
                        if (!(type != null && type.indexOf("application/json") > -1)) return [3 /*break*/, 8];
                        return [4 /*yield*/, response.json()];
                    case 7:
                        result = _a.sent();
                        _a.label = 8;
                    case 8: return [2 /*return*/, result];
                    case 9:
                        error_2 = _a.sent();
                        Sentry.captureException(error_2);
                        throw error_2;
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    return AuthClient;
}());
exports.AuthClient = AuthClient;
exports.Client = new AuthClient();
//# sourceMappingURL=AuthClient.js.map